import React from 'react';
import RadioMui, { RadioProps } from '@material-ui/core/Radio';

export const Radio: React.FC<RadioProps> = ({ children, ...rest }) => {
	return <RadioMui {...rest}>{children}</RadioMui>;
};
